import React, { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import PreviewApp from './components/PreviewApp';
import './App.css';

const PAGE_TITLES = {
  '/': 'Lori — Emotion-Aware Social Discovery',
  '/dashboard': 'Lori — Discovery Feed',
  '/experience': 'Lori — Experience Lab',
  '/algorithm': 'Lori — Algorithm Lab',
  '/insights': 'Lori — Emotional Insights',
  '/inbox': 'Lori — Messages',
  '/settings': 'Lori — Preview Settings'
};

function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || (pathname.startsWith('/u/') ? 'Lori — Demo Profile' : 'Lori — Open Preview');
  }, [pathname]);
  return null;
}

function App() {
  const previewRoutes = ['/dashboard', '/explore', '/experience', '/algorithm', '/insights', '/inbox', '/settings', '/postcast', '/highlight'];
  return (
    <Router>
      <div className="App">
        <PageTitle />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {previewRoutes.map((path) => <Route key={path} path={path} element={<PreviewApp />} />)}
          <Route path="/u/:uid" element={<PreviewApp />} />
          <Route path="/post/:id" element={<Navigate to="/dashboard" replace />} />
          <Route path="/signup" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
